(function (window, document, $) {
  "use strict";

  const unitSpacing = 16;
  const mobileBreakpoint = 1024 - unitSpacing;

  const setProjectCardImagePosition = (isMobile) => {
    if (!isMobile) {
      $(".card-project").each(function (index) {
        const $card = $(this);
        const $content = $card.find(".card-project__content");
        const $images = $card.find(".card-project__images");
        const isEven = index % 2 !== 0;

        $card.toggleClass("is-even", isEven);

        if ($content.length && $images.length) {
          if (isEven) {
            const contentLeftEdge = $content.offset().left;
            const imagesWidth = $images.outerWidth();
            $images.css("left", "0");
            $images.css("right", `calc(100% - ${contentLeftEdge}px + 8px)`);
          } else {
            const contentRightEdge =
              $content.offset().left + $content.outerWidth() + 8;
            $images.css("left", contentRightEdge + "px");
          }
        }
      });
    }
  };

  const setCommitmentIntroImagePosition = (isMobile) => {
    if (!isMobile) {
      const $intro = $(".commitment-intro");
      const $content = $intro.find(".commitment-intro__content");
      const $images = $intro.find(".commitment-intro__images");

      if ($content.length && $images.length) {
        // if (isEven) {
        const contentLeftEdge = $content.offset().left;
        // const imagesWidth = $images.outerWidth();
        $images.css("left", "0");
        $images.css("right", `calc(100% - ${contentLeftEdge}px + 8px)`);
        // } else {
        //   const contentRightEdge =
        //     $content.offset().left + $content.outerWidth() + 8;
        //   $images.css("left", contentRightEdge + "px");
        // }
      }
    }
  };

  const maskBehavior = function (val) {
      return val.replace(/\D/g, "").length === 11
        ? "(00) 00000-0000"
        : "(00) 0000-00009";
    },
    options = {
      onKeyPress: function (val, e, field, options) {
        field.mask(maskBehavior.apply({}, arguments), options);
      },
    };

  function showMessageFeedback({ type, title, message }) {
    const html = `
		  <span class="message-feedback__close"><i class="icon-close"></i></span>
      <h3 class="message-feedback__title">${title}</h3>
      <p>${message}</p>
    `;

    $(".message-feedback__content").html(html);

    setTimeout(function () {
      $(".message-feedback").addClass("is-active " + type);
    }, 200);
  }

  function changeLoaderVisibility(visible) {
    if (visible) {
      $("body").addClass("show-loader");
    } else {
      $("body").removeClass("show-loader");
    }
  }

  function ajaxContentWrapper({
    e = {},
    url,
    method = "GET",
    dataType = null,
    formData = null,
    additionalParams = {},
    callbackSuccess = (data) => {
      console.log(data);
    },
    callbackError = (data) => {
      console.log(data);
    },
    timeout = 0,
  }) {
    $.ajax({
      ...additionalParams,
      url,
      method,
      dataType,
      data: formData,
      beforeSend: function () {
        changeLoaderVisibility(true);
      },
      success: function (data) {
        callbackSuccess(data);
      },
      error: function (data) {
        callbackError(data);
      },
      complete: function () {
        changeLoaderVisibility(false);
      },
    });
  }

  function controlPageOverflow(auto = true) {
    if (auto) {
      $("html, body").css("overflow-y", "auto");
    } else {
      $("html, body").css("overflow-y", "hidden");
    }
  }

  $(document).ready(() => {
    const isMobile = $(window).width() < mobileBreakpoint;

    setProjectCardImagePosition(isMobile);
    // setCommitmentIntroImagePosition(isMobile);

    // $(".main-menu .menu-item-has-children").each(function (index, parentItem) {
    //   const parentId = $(parentItem).attr("id");
    //   const subMenu = $(parentItem).find(".sub-menu");

    //   if (!parentId || !subMenu.length) {
    //     return;
    //   }

    //   $(parentItem).attr("data-id", parentId);

    //   const subMenuHtml = $("<ul class=\"main-navigation-submenu__items\"></ul>")
    //     .attr("data-id", parentId)
    //     .html(subMenu.html());

    //   $("#main-navigation-submenu .container").append(subMenuHtml);
    // });

    // $(".main-menu .menu-item-has-children").on("mouseenter", function () {
    //   if (isMobile) return;

    //   const parentId = $(this).data("id");
    //   const subMenuContainer = $("#main-navigation-submenu");
    //   const targetSubMenuItems = subMenuContainer.find(
    //     '.main-navigation-submenu__items[data-id="' + parentId + '"]'
    //   );

    //   subMenuContainer.addClass("is-active");
    //   targetSubMenuItems
    //     .addClass("is-active")
    //     .siblings()
    //     .removeClass("is-active");
    // });

    // $("#main-navigation-submenu").on("mouseleave", function () {
    //   $(this).removeClass("is-active");
    // });

    // $(".menu-item-has-children a").click(function (e) {
    //   if (!isMobile) {
    //     e.preventDefault();
    //   }
    // });

    $(".phone").mask(maskBehavior, options);

    $(".menu-trigger").click(function () {
      $(".header").toggleClass("is-menu-opened");

      controlPageOverflow(!$(".header").hasClass("is-menu-opened"));
    });

    const homeSlideshow = new Swiper(".home-slideshow .swiper", {
      speed: 1000,
      loop: true,
      slidesPerView: 1,
      spaceBetween: 0,
      navigation: {
        nextEl: ".home-slideshow .swiper-button-next",
        prevEl: ".home-slideshow .swiper-button-prev",
      },
    });

    // const brandsSwiper = new Swiper(".brands .swiper", {
    //   loop: true,
    //   autoplay: {
    //     delay: 100,
    //     disableOnInteraction: false,
    //   },
    //   speed: 1000,
    //   allowTouchMove: false,
    //   slidesPerView: "auto",
    //   spaceBetween: 40,
    //   breakpoints: {
    //     1400: {
    //       slidesPerView: 6,
    //       spaceBetween: 80,
    //     },
    //   },
    // });

    const testimonials = new Swiper(".testimonials__slider", {
      loop: true,
      // autoHeight: true,
      centeredSlides: true,
      slidesPerView: 1,
      spaceBetween: 24,
      navigation: {
        nextEl: ".testimonials .swiper-button-next",
        prevEl: ".testimonials .swiper-button-prev",
      },
      breakpoints: {
        600: {
          slidesPerView: "auto",
        },
        // 1024: {
        //   slidesPerView: 3,
        // },
      },
    });

    $(".card-project").each(function (index) {
      const $card = $(this);
      const swiperContainer = $card.find(".swiper")[0];
      const isEven = index % 2 !== 0;

      if (swiperContainer) {
        if (isEven && !isMobile) {
          $(swiperContainer).attr("dir", "rtl");
        }
        new Swiper(swiperContainer, {
          loop: true,
          slidesPerView: "auto",
          spaceBetween: 8,
          navigation: {
            nextEl: $card.find(".swiper-button-next")[0],
            prevEl: $card.find(".swiper-button-prev")[0],
          },
        });
      }
    });

    const swiperIntroContainer = $(".commitment-intro .swiper")[0];
    if (swiperIntroContainer) {
      if (!isMobile) {
        $(swiperIntroContainer).attr("dir", "rtl");
      }

      const commitmentIntroSwiper = new Swiper(".commitment-intro .swiper", {
        loop: true,
        slidesPerView: "auto",
        spaceBetween: 8,
        speed: 1000,
        allowTouchMove: false,
        autoplay: {
          delay: 1000,
          disableOnInteraction: false,
        },
      });
    }

    $(".filter__label").click(function () {
      $(this).parent().toggleClass("is-filter-openned");
    });

    $("body").on("click", ".accordion-item__header", function () {
      const parentAccordion = $(this).parent().parent();
      const currentItem = $(this).parent();
      const currentItemContent = currentItem.find(".accordion-item__content");
      const contentHeight = currentItem
        .find(".accordion-item__content-inner")
        .outerHeight();

      if (currentItem.hasClass("is-active")) {
        currentItem.removeClass("is-active");
        currentItemContent.css({ "max-height": "0" });
      } else {
        parentAccordion
          .find(".is-active")
          .removeClass("is-active")
          .find(".accordion-item__content")
          .css({ "max-height": "0" });
        currentItem.addClass("is-active");
        currentItemContent.css({ "max-height": contentHeight });
      }
    });

    $(".accordion").each(function () {
      const $accordion = $(this);
      const $accordionItems = $accordion.find(".accordion-item");
      const $firstItem = $accordionItems.first();

      $firstItem.find(".accordion-item__header").trigger("click");
    });

    // $(".js-open-modal").click(function (e) {
    //   e.preventDefault();

    //   const modal = $(this).data("modal");
    //   const modalToOpen = $(`.modal[data-modal="${modal}"]`);
    //   modalToOpen.addClass("is-active");
    //   controlPageOverflow(false);
    // });

    // $("body").on("click", ".modal", function (e) {
    //   const target = $(e.target);

    //   if ($(".modal.is-active").is(target)) {
    //     $(".modal__close").trigger("click");
    //   }
    // });

    // $("body").on("click", ".modal__close", function (e) {
    //   $(".modal").removeClass("is-active");
    //   controlPageOverflow(true);
    // });

    const projectsSliderSwiper = new Swiper(".projects__slider", {
      loop: true,
      slidesPerView: "auto",
      spaceBetween: 8,
      centeredSlides: true,
      navigation: {
        nextEl: ".projects__slider .swiper-button-next",
        prevEl: ".projects__slider .swiper-button-prev",
      },
      pagination: {
        el: ".projects__slider .swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        1200: {
          slidesPerView: 5,
          centeredSlides: false,
        },
      },
    });

    const latestPostsSliderSwiper = new Swiper(
      ".latest-posts__slider .swiper",
      {
        loop: true,
        slidesPerView: "auto",
        spaceBetween: 8,
        centeredSlides: true,
        navigation: {
          nextEl: ".latest-posts__slider .swiper-button-next",
          prevEl: ".latest-posts__slider .swiper-button-prev",
        },
        pagination: {
          el: ".latest-posts__slider .swiper-pagination",
          clickable: true,
        },
        breakpoints: {
          1200: {
            slidesPerView: 3,
            centeredSlides: false,
          },
        },
      }
    );

    $(".home-products__grid").masonry({
      itemSelector: ".home-products__item",
      columnWidth: ".grid-sizer",
      percentPosition: true,
      gutter: isMobile ? 24 : 0,
    });

    $(".ajax-form").submit(function (e) {
      e.preventDefault();
      const form = $(this);
      const formEl = form[0];
      const formAction = form.attr("action");
      const hasFileInput = form.find(".form-file").length > 0;
      let additionalParams = {};
      let formData = form.serialize();

      if (hasFileInput) {
        additionalParams = {
          enctype: "multipart/form-data",
          processData: false,
          contentType: false,
          cache: false,
        };

        formData = new FormData(formEl);
      }

      form.find(".form-group").addClass("with-success");
      form
        .find(".form-group,.form-checkbox,.form-file")
        .removeClass("with-error");
      form.find(".field-feedback").text("");

      ajaxContentWrapper({
        url: formAction,
        formData,
        additionalParams,
        method: "POST",
        callbackSuccess: (response) => {
          if (response.data.errors) {
            const errors = Object.keys(response.data.errors);

            errors.forEach((error) => {
              form
                .find(`#${error}`)
                .parent()
                .removeClass("with-success")
                .addClass("with-error");
              form
                .find(`#${error}`)
                .parent()
                .find(".field-feedback")
                .text(response.data.errors[error]);
            });
          }

          showMessageFeedback({
            type: response.success ? "success" : "error",
            message: response.data.message,
            title: response.data.title,
          });

          if (response.success) {
            form[0].reset();
            form
              .find(".form-group,.form-checkbox")
              .removeClass("with-success with-error");

            const stateSelect = form.find(".state-select");
            const citySelect = form.find(".city-select");

            stateSelect.val("").trigger("change");
            citySelect.val("").trigger("change");
          }
        },
        callbackError: (error) => {
          console.error(error.responseText);
          showMessageFeedback({
            type: "error",
            title: error.data.title,
            message: error.data.message
              ? error.data.message
              : "Erro ao enviar mensagem.",
          });
        },
      });
    });

    $(".message-feedback").on("click", function (e) {
      const target = $(e.target);

      if (
        target.hasClass("is-active") ||
        target.is(".icon-close") ||
        target.is(".message-feedback__close")
      ) {
        $(".message-feedback").removeClass("is-active success error");

        setTimeout(() => {
          $(".message-feedback__content").empty();
        }, 400);
      }
    });

    $(".form-select").select2({
      width: "100%",
      minimumResultsForSearch: 20,
      language: "pt-BR",
    });

    $(".state-select").change(function () {
      const stateSelect = $(this);
      const state = stateSelect.val();
      const citySelect = stateSelect
        .closest(".form-2-columns")
        .find(".city-select");

      if (!state) {
        citySelect.html(
          '<option value="" selected disabled>Selecione primeiro o estado</option>'
        );
        return;
      }

      ajaxContentWrapper({
        url: `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${state}/municipios`,
        method: "GET",
        beforeSend: function () {
          citySelect
            .html('<option value="" selected disabled>Carregando...</option>')
            .prop("disabled", true);
        },
        callbackSuccess: (cities) => {
          let options =
            '<option value="" selected disabled>Selecione a cidade</option>';
          cities.forEach((city) => {
            options += `<option value="${city.nome}">${city.nome}</option>`;
          });
          citySelect.html(options).prop("disabled", false);

          // Trigger Select2 to update its UI
          citySelect.trigger("change");
        },
        callbackError: (error) => {
          console.error("Erro ao buscar cidades:", error);
          citySelect
            .html(
              '<option value="" selected disabled>Erro ao carregar cidades</option>'
            )
            .prop("disabled", true);

          // Trigger Select2 to update its UI
          citySelect.trigger("change");
        },
      });
    });

    // Helper function to update the displayed selected filters in the UI
    function updateSelectedFiltersUI() {
      const $selectedContainer = $(".filter__selected");
      // Remove all dynamically added spans, keep the "Clear all" button
      $selectedContainer.find("span:not(.filter__selected-clear)").remove();

      // Add spans for currently selected filters
      $(".js-isotope-filter .filter__item-link--selected").each(function () {
        const $this = $(this);
        const filterValue = $this.attr("data-filter");
        const filterText = $this.text();
        const $newSpan = $(
          `<span data-id="${filterValue.substring(
            1
          )}">${filterText} <i class="icon-close"></i></span>`
        );
        // Prepend new span before the "Clear all" button
        $selectedContainer.prepend($newSpan);
      });

      // Show/hide the entire selected filters container
      if (
        $selectedContainer.find("span:not(.filter__selected-clear)").length > 0
      ) {
        $selectedContainer.show();
      } else {
        $selectedContainer.hide();
      }
    }

    // Function to apply combined Isotope filters and update UI
    function applyCombinedFilters() {
      if (!$(".js-isotope-filter").length) return;

      const categoryFilters = $(
        ".js-isotope-filter .filter__item-link--selected"
      )
        .map(function () {
          return $(this).attr("data-filter");
        })
        .get(); // e.g., ['.area-gourmet', '.banheiro']

      const searchValue = $("#filter-search").val().toLowerCase();

      $grid.isotope({
        filter: function () {
          const $item = $(this);
          const itemText = $item.text().toLowerCase();

          const searchMatch = searchValue
            ? itemText.includes(searchValue)
            : true;
          const categoryMatch =
            categoryFilters.length > 0
              ? $item.is(categoryFilters.join(","))
              : true;

          return searchMatch && categoryMatch;
        },
      });

      updateSelectedFiltersUI(); // Update UI after applying filters
    }

    // Isotope Filtering
    const $grid = $(".js-isotope-grid").isotope({
      itemSelector: ".card-project",
      layoutMode: "masonry", // or 'masonry', etc.
    });

    // Initial UI update for selected filters
    applyCombinedFilters();

    // Handle clicks on dynamically added selected filter spans
    $(".filter__selected").on(
      "click",
      "span:not(.filter__selected-clear)",
      function () {
        const $this = $(this);
        const filterId = $this.attr("data-id");
        $(`.js-isotope-filter a[data-filter=".${filterId}"]`).removeClass(
          "filter__item-link--selected"
        );
        applyCombinedFilters();
      }
    );

    // Debounce function to limit how often a function can run.
    function debounce(fn, delay) {
      // 'fn' is the original event handler function
      let timeoutId;
      return function (...args) {
        // This is the function returned by debounce, which becomes the actual event handler
        const context = this; // Capture the 'this' context from the event handler (the DOM element)
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
        timeoutId = setTimeout(() => {
          fn.apply(context, args); // Apply the captured 'this' context when calling the original function
        }, delay);
      };
    }

    // Filter based on search input
    const $quicksearch = $("#filter-search").on(
      "keyup",
      debounce(function () {
        applyCombinedFilters();
      }, 200)
    );

    // Filter based on category links clicks
    $(".js-isotope-filter").on("click", "a", function (e) {
      e.preventDefault();
      const $this = $(this);

      // Toggle selection
      if ($this.hasClass("filter__item-link--selected")) {
        $this.removeClass("filter__item-link--selected");
      } else {
        $this.addClass("filter__item-link--selected");
      }

      applyCombinedFilters();
    });

    // Handle "Limpa tudo" (Clear all) click
    $(".filter__selected-clear").on("click", function () {
      $(".js-isotope-filter .filter__item-link--selected").removeClass(
        "filter__item-link--selected"
      );
      applyCombinedFilters();
    });

    function updateBlogFilterUrl() {
      const $form = $(".filter__form");
      if (!$form.length) return;

      const baseUrl = $form.attr("action");
      const categories = $form
        .find("input[name='categorias[]']:checked")
        .map(function () {
          return $(this).val();
        })
        .get();

      const searchQuery = $form.find("input[name='s']").val();
      const urlParams = new URLSearchParams();

      if (categories.length > 0) {
        urlParams.set("categorias", categories.join(","));
      }

      if (searchQuery) {
        urlParams.set("s", searchQuery);
      }

      window.location.href = `${baseUrl}?${urlParams.toString()}`;
    }

    // Server-side filter logic
    $(".filter__form").on("submit", function (e) {
      e.preventDefault();
      updateBlogFilterUrl();
    });

    $(".filter__form .filter__selected").on(
      "click",
      "span:not(.filter__selected-clear)",
      function () {
        const $this = $(this);
        const filterId = $this.attr("data-id");
        const $form = $this.closest("form");

        if (filterId === "search_query") {
          $form.find('input[name="s"]').val("");
        } else {
          $form
            .find(`input[type="checkbox"][value="${filterId}"]`)
            .prop("checked", false);
        }

        updateBlogFilterUrl();
      }
    );

    $(".filter__form").on("change", "input[type='checkbox']", function () {
      updateBlogFilterUrl();
    });
  });

  $(window).scroll(() => {});

  $(window).resize(() => {
    const isMobile = $(window).width() < mobileBreakpoint;
    setProjectCardImagePosition(isMobile);
    // setCommitmentIntroImagePosition(isMobile);
  });
})(window, document, jQuery);

(function (document, window, index) {
  var inputs = document.querySelectorAll(".inputfile");
  Array.prototype.forEach.call(inputs, function (input) {
    var label = input.nextElementSibling,
      labelVal = label.innerHTML;

    input.addEventListener("change", function (e) {
      var fileName = "";
      if (this.files && this.files.length > 1)
        fileName = (this.getAttribute("data-multiple-caption") || "").replace(
          "{count}",
          this.files.length
        );
      else fileName = e.target.value.split("\\").pop();

      if (fileName) label.querySelector("span").innerHTML = fileName;
      else label.innerHTML = labelVal;
    });

    // Firefox bug fix
    input.addEventListener("focus", function () {
      input.classList.add("has-focus");
    });
    input.addEventListener("blur", function () {
      input.classList.remove("has-focus");
    });
  });
})(document, window, 0);
